@use '../../../assets/styles/utilities.scss';

:host {
  display: block;
}

.nav-footer-animate {
  opacity: 0;
  transform: translateY(30px);
  animation: navFooterIn 0.5s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

@keyframes navFooterIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.btmbar_badge {
  display: inline-block;
  padding: 0rem 0.25rem;
  font-size: 0.625rem;
  font-weight: 600;
  border-radius: 2px;
  transition: all 15s ease-in-out;
  text-align: center;
  white-space: nowrap;
  background-color: #dc2626;
  color: white;
  border: 1px solid #dc2626;
  top: -8px;
  left: 10px;
}
.footer {
  box-shadow: 0 -4px 6px rgba(0, 0, 0, 0.1);
}

.footer-item {
  position: relative;
  overflow: hidden; // contain ripple
  --rp-x: 50%;
  --rp-y: 50%;

  &::after {
    content: '';
    position: absolute;
    top: var(--rp-y);
    left: var(--rp-x);
    width: 0;
    height: 0;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.08);
    opacity: 0;
    pointer-events: none;
  }

  &.clicked::after {
    width: 200%;
    height: 200%;
    opacity: 1;
    transition: width 420ms ease, height 420ms ease, opacity 520ms ease;
  }

  // nice tactile press
  &:active {
    transform: translateY(0.5px) scale(0.98);
    transition: transform 120ms ease;
  }
}

.footer-item-icon {
  transition: transform 140ms ease;
}
.footer-item:active .footer-item-icon {
  transform: scale(1.06);
}
